import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Menu, MenuItem, Tooltip } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';

const ExportCsvButton = ({ onCsvClick, onExcelClick, onClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleIconClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCsv = () => {
    handleClose();
    (onCsvClick || onClick)();
  };

  const handleExcel = () => {
    handleClose();
    onExcelClick();
  };

  return (
    <>
      <Tooltip title="Exporter">
        <IconButton size="small" onClick={handleIconClick} style={{ marginLeft: 8 }}>
          <GetAppIcon style={{ color: '#001C56' }} />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleCsv}>Exporter en CSV</MenuItem>
        <MenuItem onClick={handleExcel}>Exporter en Excel</MenuItem>
      </Menu>
    </>
  );
};

ExportCsvButton.propTypes = {
  onCsvClick: PropTypes.func,
  onExcelClick: PropTypes.func.isRequired,
  onClick: PropTypes.func
};

export default ExportCsvButton;
